var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.93 131.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:screen;}.cls-3{fill:#33b8ce;}.cls-4,.cls-5{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-4{stroke:#33b8ce;}.cls-5{stroke:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 76,
    height: 30,
    transform: "translate(8.23 31.4)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAeCAYAAACG0fjXAAAACXBIWXMAAAsSAAALEgHS3X78AAAEpElEQVRoQ+2Z7U8bRxCHn7MNJjYvAULbqFXVSu3//9/0e5OogaYpmDcbY+fyYWbY8bD3YpuYIvUnrc6Hz7O7z83OzixFWZb8r/bqNT3wQlSE6zIqw7VWOWCx01aGNiwPqAA6QFevy0ArgS/AXK+la1lFYB3XIBmx63OpClAXmcM2sKPXLu2glQioKTAB7oB7YIbMNztnD6yj931tHf3xVJt/C5tQQTOgHeAVsAscAEP9rsnTzAmmwA1wAVwC13o/0e9mBI8zYDaoHeAQeINAm6ihS+CWBM4beUqAEVIP2ELGEgG9BvaAfWTMxwi0PgK2SXPEq0bAJ23/6PUzAtHm/OAo3sO6wAB4C/wGHKnBv4FTNXaJQJwhHca1D+0BxkCdgzRA4OwjgPZZBHSo93v6vfewJpmHXQPnCKQz4APwp7ZTBOiUAMwG+wo4AX4HftG/fwLeq6EzNTBGwHnXjQDrFAO1fe6zuMSOEDAn2iKgXX3evG+VGHaHzOca+Bf4C/gOsWtQH1ZVLoYNkcH9igzsBoH3AfiIvIlL4Apx22seA7QOciqQSflAbR61S/KeE+B7vZo37fEYUI8U35piV1SJePEei167g4D8jEC8tR/kdskeMqjXCOlSrz/pj0cIMHPjcxYB3pDWfU4dZKJDxIt2kQEO9N686RjxMHtmQDWguLyXkXn3NslDx8APLMbEguBhJvOALQTcNunNv0W8yFz4AgHlAY6QtzOPhlW29A5IgXqAQLNgvk+C1EfG0uNpAEV5eyDjGJL67vnv6zJ9D84vmTkp3bBlaABHLHpYXJYWu7yHDUlQbJlWQXoKQHXysdXaQp9tSiMzYsvVdkTLkCPAVWJYDP6bhFSlbL9tgJniMqgCuMouGW0/F6RGLQMsqg5gG20CTm4sa/W3DrCoTQDIqSphNq83j/ehxY9xqXHngJWh/dfkAVWFAktKfR0cUweLjz40NM45ArPO77VZUH/O4FsFqG6z8YX1FTKXLSRBtfLJdkG/M3dJVUsWnAf2RR8eI3nVBZITFYhB/1a+Jby2gKrSGXvWCusL/dxH5nOAzMdOZoak3G+AeNoYgfxoAzNgNrAJks2/UyMg5ckBksR+iwRyFUBNCbMtxxt9fkpKwC3v6yHgfHVxpM+M1f4dAZr3sDlSM30E/kA6OQd+RsqEQ5pLFDJXrxig1wFUV5L5GGYQrcKIyzHWr8f63ZnavycDzAY+Rk4nZvrwKXLM8SPiaXVFcFXyaYoB2j6vCqip6Lf+qnbJggTRn7Ed6v0YOdoae7tF+K+RTdbOovYRSG+0VR2z5Mobvxv5N26Tu0fevp14rgKo6VgpF7hjSmH54xapjuwj9q60TVBoEZg34neQIfUHebGA9sfFBsxiygiZ/AQJASPWAxSX+bLyG1kXgWcrb0Y65896mJd3YXsDuaPi3BGNPy7uIJOzXcsC9C0Cwna5TQGqUxGaLeuHvuqAPTzjmq/ke+QPAf0phB0X+7zIUgD7L41fppsGVCcDtvjHFsC8/A7oAfpgH2OYKcawGPyfG1ArLQssKpdKtN0lI5i1BrIprQssp2XysBenpzytML14KHX6Cob/IGmwlRgtAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.57,37.87l.23,12.86S22,54.5,29.31,55.38,43.06,53.83,54.37,51,72.54,49.17,79,52.72l-.16-12.8A34.07,34.07,0,0,0,66.5,36.43c-4.21-.22-9,1-15.46,3S36.3,44.13,27.43,42.58,13.57,37.87,13.57,37.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.57,37.87l.23,12.86S22,54.5,29.31,55.38,43.06,53.83,54.37,51,72.54,49.17,79,52.72l-.16-12.8A34.07,34.07,0,0,0,66.5,36.43c-4.21-.22-9,1-15.46,3S36.3,44.13,27.43,42.58,13.57,37.87,13.57,37.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.47,121.59s-5.85-9.65-20.49-7.23-25.16,8-37.45,7.23-19.32-4.82-19.32-4.82V3.3s7,4,19.32,4.82S49.35,3.3,64,.89,84.47,8.12,84.47,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,23.68a46.81,46.81,0,0,0,11.79,2.24c10.15.67,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,23.68A46.81,46.81,0,0,1,139,25.92c-10.15.67-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,37A46.81,46.81,0,0,1,139,39.22c-10.15.67-18.86-4-30.95-6A18.34,18.34,0,0,0,95.88,35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,43.55A47.26,47.26,0,0,1,139,45.79c-10.15.66-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,50.11A46.81,46.81,0,0,1,139,52.35c-10.15.67-18.86-4-30.95-6a18.27,18.27,0,0,0-12.17,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,56.67A46.36,46.36,0,0,1,139,58.91c-10.15.67-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139,65.48c-10.15.66-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,76.36A46.74,46.74,0,0,1,139,78.61c-10.15.66-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,82.93A46.81,46.81,0,0,1,139,85.17c-10.15.66-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,89.49A46.81,46.81,0,0,1,139,91.73c-10.15.67-18.86-4-30.95-6A18.34,18.34,0,0,0,95.88,87.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.79,96.05A46.74,46.74,0,0,1,139,98.3c-10.15.66-18.86-4-30.95-6a18.34,18.34,0,0,0-12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,30.24a46.81,46.81,0,0,0,11.79,2.24c10.15.67,18.86-4,31-6a18.27,18.27,0,0,1,12.17,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,36.8A46.81,46.81,0,0,0,30.74,39c10.15.66,18.86-4,31-6A18.34,18.34,0,0,1,73.86,34.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,56.47a46.36,46.36,0,0,0,11.79,2.24c10.15.67,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,63a46.81,46.81,0,0,0,11.79,2.24c10.15.67,18.86-4,31-6A18.34,18.34,0,0,1,73.86,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,69.59a46.81,46.81,0,0,0,11.79,2.24c9.7.64,18.08-3.58,29.36-5.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,76.15a46.81,46.81,0,0,0,11.79,2.24c10.15.66,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,82.71A46.81,46.81,0,0,0,30.74,85c10.15.66,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,89.26a46.74,46.74,0,0,0,11.79,2.25c10.15.66,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,95.82a46.74,46.74,0,0,0,11.79,2.25c10.15.66,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,102.38a46.81,46.81,0,0,0,11.79,2.24,33.9,33.9,0,0,0,7.42-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.47,121.59s5.85-9.65,20.48-7.23,25.17,8,37.46,7.23S161.72,118,161.72,118V4.51s-7,2.8-19.31,3.61S119.58,3.3,105,.89,84.47,8.12,84.47,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.5,10.27V126.69H74.81s2.88,4.79,9.86,4.79,9.76-4.79,9.76-4.79h74V8.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,43.36A47.26,47.26,0,0,0,30.74,45.6c10.15.66,18.86-4,31-6a18.34,18.34,0,0,1,12.17,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,49.91a46.74,46.74,0,0,0,11.79,2.25c6.05.39,11.58-1.1,17.62-2.78"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.6298dc41d88da44a99d16bbf09fa3735.svg";
export { ForwardRef as ReactComponent };